<template>
  <div>
    <a-modal
      title="录入指纹"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      width="480px"
      centered
      :keyboard="false"
      :maskClosable="false"
      @cancel="handleCancel"
      okText="保存"
      :getContainer="getContainer"
    >
      <div class="content">
        <div class="contentValue">
          <img
            v-if="!fingerImage"
            class="fingerImage"
            src="@/assets/image/img_zw.png"
            alt=""
          />
          <img v-else class="fingerImage2" :src="fingerImage" alt="" />
          <div v-show="!fingerImage" class="shibie"></div>
        </div>
      </div>
      <div style="display: flex; justify-content: center; height: 50px">
        <a-button @click="initFinger" v-if="fingerImage && !confirmLoading"
          >重新录入</a-button
        >
      </div>
    </a-modal>
  </div>
</template>

<script>
import GetFingerImage from "@/utils/fingerprint/index";
import { ClippingImage, dataURLtoBlob } from "@/utils/os";
import { upload } from "@/request/sys";
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      finger: null,
      fingerImage: "",
    };
  },
  methods: {
    init() {
      this.visible = true;
      this.initFinger();
    },
    initFinger() {
      this.fingerImage = "";
      this.finger = new GetFingerImage();
      this.finger.init();
      this.finger.setSuccessCallback(this.setSuccessCallback);
      this.finger.setTimeoutCallback(this.setTimeoutCallback);
      this.finger.setOfflineCallback(() => {
        this.$error({
          title: "指纹采集器未连接",
          content: "请检查指纹采集器是否插入电脑的USB口",
          getContainer: ()=> document.getElementById("bodyContnet"),
          onOk: () => {
            this.handleCancel();
          },
        });
      });
    },
    setSuccessCallback(res) {
      this.fingerImage = res;
    },
    //指纹超时
    setTimeoutCallback() {
      this.$confirm({
        title: "录入超时，是否开始重新录入？",
        content: "请在在10秒进行内录入",
        okText: "重新录入",
        cancelText: "暂时不录入了",
        getContainer: ()=> document.getElementById("bodyContnet"),
        onOk: () => {
          console.log("OK");
          this.initFinger();
        },
        onCancel: () => {
          console.log("Cancel");
          this.handleCancel();
        },
      });
    },
    handleOk() {
      this.confirmLoading = true;
      const file = dataURLtoBlob(
        this.fingerImage,
        encodeURIComponent("指纹图片")
      );
      let formData = new FormData();
      formData.append("file", file);
      upload(formData)
        .then((res) => {
          this.$emit("getImg", res.data.url);
          this.handleCancel();
        })
        .finally(() => (this.confirmLoading = false));
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.fingerImage = "";
      if (this.finger) {
        this.finger.close();
        this.finger = null;
      }
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style scoped>
.content {
  width: 180px;
  height: 180px;
  margin: 0px auto 20px;
  background: #e6e8f0;
  border-radius: 50%;
  padding: 4px;
}

.contentValue {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.fingerImage {
  width: 100px;
  height: 100px;
}

.fingerImage2 {
  width: 100px;
  height: 133px;
}

.shibie {
  width: 100%;
  height: 2px;
  position: absolute;
  /* background: red; */
  background-image: linear-gradient(
    rgba(97, 222, 242, 0) 0%,
    rgba(97, 222, 242, 1) 25%,
    rgba(97, 222, 242, 1) 75%,
    rgba(97, 222, 242, 0) 100%
  );
  left: 0;
  top: 0%;
  transform: translateY(0px);
  /* transform: translateY(-50%); */
  animation: loop 5s linear infinite;
}

/* 定义动画关键帧 */
@keyframes loop {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(172px);
  }

  100% {
    transform: translateY(0);
  }
}
</style>